// useLogout.js
import useUser from '@/ui/providers/userProvider';
import { useRouter } from 'next/navigation';
import { useState } from 'react';
import { oryFrontendClient } from '@/integrations/ory/ory-frontend-client';
import { errorMessages } from '@/utils/error-messages';

export const useLogout = () => {
  const { clearSessionAndCustomer } = useUser();
  const router = useRouter();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const logout = async (returnTo?: string) => {
    setLoading(true);
    setError('');

    try {
      const { data } = await oryFrontendClient.createBrowserLogoutFlow({ returnTo });
      clearSessionAndCustomer();
      router.push(data.logout_url);
    } catch (e) {
      setError(errorMessages.failedLogout);
      setLoading(false);
    }
  };

  return { logout, loading, error };
};
